import React, { useState } from "react";
import axios from "axios";
import { env } from "../config";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setStatus({ type: "error", message: "Please enter your email address." });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      setStatus({ type: "error", message: "Please enter a valid email address." });
      return;
    }

    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await axios.post(`${env.baseUrl}/api/newsletter/subscribe`, {
        email: trimmedEmail,
        preference: "both",
        preferences: ["blogs", "events"],
        source: "footer",
      });

      setStatus({
        type: "success",
        message: response.data?.message || "Subscribed successfully! Check your inbox.",
      });
      setEmail("");
    } catch (error) {
      const message =
        error?.response?.data?.errors?.email?.[0] ||
        error?.response?.data?.message ||
        "Subscription failed. Please try again later.";
      setStatus({ type: "error", message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-3 footer-logo">
            <img
              className="mb-2"
              src="/images/white-logo.png"
              alt="Yalla Lebanon"
              style={{ width: "150px", height: "auto" }}
            />
            <p>Discover the stories, culture and events of Lebanon.</p>
          </div>

          <div className="col-lg-6 col-md-5 our-links">
            <div className="row">
              <div className="col">
                <h3>Explore</h3>
                <ul>
                  <li><a href="/">Home</a></li>
                  <li><a href="/this-week">This Week</a></li>
                  <li><a href="/categories">Categories</a></li>
                  <li><a href="/agendas">Agendas</a></li>
                  <li><a href="/legacy">Legacy</a></li>
                </ul>
              </div>
              <div className="col">
                <h3>About</h3>
                <ul>
                  <li><a href="/about-us">About Us</a></li>
                  <li><a href="/press">Press</a></li>
                  <li><a href="/contact">Contact</a></li>
                  <li><a href="/subscriptions">Subscription</a></li>
                </ul>
              </div>
              <div className="col">
                <h3>Lebanese Legacy</h3>
                <ul>
                  <li><a href="/yesterday">Yesterday</a></li>
                  <li><a href="/today">Today</a></li>
                  <li><a href="/forever">Forever</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 subscribe">
            <h3>Subscribe Now</h3>
            <p>Receive stories, events and updates from Lebanon</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group position-relative mt-3">
                <input
                  className="form-control"
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  className="btn-submit"
                  disabled={loading}
                >
                  {loading ? "..." : "Subscribe"}
                </button>
              </div>
              {status.message && (
                <p
                  className={status.type === "error" ? "text-danger" : "text-success"}
                  style={{ marginTop: "8px", fontSize: "14px" }}
                >
                  {status.message}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="bottom-block d-flex justify-content-between">
          <p>© yallalebanon.com</p>
          <a href="/privacy-policy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
